import { createReducer } from '@reduxjs/toolkit'

import * as openedPagesActions from './openedPages.actions'

const initialState = {
  activeItem: '',
  search: '',
  list: {},
  order: [],
}

export const openedPagesReducer = createReducer(initialState, {
  [openedPagesActions.add.toString()]: (state, action) => {
    const { id, name, icon, hint, shortName, search } = action.payload
    state.activeItem = id
    state.search = search
    state.list[id] = {
      name,
      icon,
      uri: id,
      hint,
      shortName,
    }
    state.order = state.order.indexOf(id) !== -1 ? state.order : [...state.order, id]
  },
  [openedPagesActions.select.toString()]: (state, action) => {
    state.activeItem = action.payload
  },
  [openedPagesActions.remove.toString()]: (state, action) => {
    const { id, nextActiveItem } = action.payload

    delete state.list[id]

    state.activeItem = typeof nextActiveItem === 'function' ? nextActiveItem(state.order, id) : nextActiveItem
    state.order = state.order.filter((item) => item !== id)
  },
  [openedPagesActions.reset.toString()]: () => initialState,
})
